import { Box, styled } from "@mui/material";
import { Icon } from "../Icon";

export const StyledIndicatorWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSmall",
})<{
  isSmall?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({
    theme: {
      wsc: { size },
    },
    isSmall,
  }) => (isSmall ? size.m : size.l)};
  min-width: ${({
    theme: {
      wsc: { size },
    },
    isSmall,
  }) => (isSmall ? size.m : size.l)};
  height: ${({
    theme: {
      wsc: { size },
    },
    isSmall,
  }) => (isSmall ? size.m : size.l)};
  border-radius: ${(props) => props.theme.wsc.radius.half};
  background-color: ${(props) => props.theme.wsc.palette.neutral[800]};
  color: ${(props) => props.theme.wsc.palette.neutral[100]};
  border: 1px solid ${(props) => props.theme.wsc.palette.neutral[200]};
`;

export const StyledIcon = styled(Icon)`
  display: flex;
  padding: ${(props) => props.theme.wsc.spacing[1]};
`;

export const StyledIndicatorShortcut = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSmall",
})<{
  isSmall?: boolean;
}>`
  position: absolute;
  bottom: -3px;
  left: -1px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1px;
  width: ${({
    theme: {
      wsc: { size },
    },
    isSmall,
  }) => (isSmall ? size.s : `calc(${size.l} / 2)`)};
  min-width: ${({
    theme: {
      wsc: { size },
    },
    isSmall,
  }) => (isSmall ? size.s : `calc(${size.l} / 2)`)};
  height: ${({
    theme: {
      wsc: { size },
    },
    isSmall,
  }) => (isSmall ? size.s : `calc(${size.l} / 2)`)};
  border-radius: ${(props) => props.theme.wsc.radius.half};
  background-color: ${(props) => props.theme.wsc.palette.neutral[0]};
`;
